var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metric-list"},_vm._l((_vm.list),function(metric){return _c('MetricItem',{key:metric.category_id,attrs:{"metricType":_vm.metricType,"metric":metric},on:{"showDetails":_vm.showDetails}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }